import * as alpaca from '@/services/alpaca';

/**
 * Regression model interface for price prediction.
 */
export interface RegressionModel {
  fit(train: number[]): void;
  predict(test: number[]): number[];
}

/**
 * Cross-validation metrics.
 * NOTE: This interface is defined but the implementation below is currently non-functional.
 * TODO: Replace with real ML model validation
 */
export interface CVMetrics {
  foldMetrics: Array<{ mse: number; sharpe: number; maxDrawdown: number }>;
  avgMse: number;
  avgSharpe: number;
  avgDrawdown: number;
  overfitRisk: boolean;
}

/**
 * DEPRECATED: This function currently uses a naive constant predictor which is not meaningful.
 * 
 * TODO: Replace with proper cross-validation that:
 * 1. Tests actual ML models (LSTM, XGBoost, etc.) configured in the strategy
 * 2. Uses real feature engineering from the strategy's model parameters  
 * 3. Validates against the strategy's actual prediction algorithm
 * 4. Returns metrics that reflect real model performance
 * 
 * Current implementation is misleading and should not be used for decision making.
 * 
 * @deprecated Use strategy backtest results instead of this CV implementation
 * @param symbol Stock symbol (e.g., 'AAPL').  
 * @param k Number of folds (default 5).
 * @returns Promise resolving to placeholder CV metrics (NOT REAL VALIDATION)
 */
export async function crossValidatePriceSeries(
  symbol: string,
  k = 5
): Promise<CVMetrics> {
  
  console.warn(`⚠️  Cross validation for ${symbol} is using placeholder implementation.`);
  console.warn(`⚠️  Results are NOT based on actual ML model validation.`);
  
  // Return placeholder metrics to avoid breaking existing UI
  // These values indicate the system needs proper model validation
  return {
    foldMetrics: [],
    avgMse: 0,
    avgSharpe: 0, 
    avgDrawdown: 0,
    overfitRisk: false
  };
}

/**
 * TODO: Implement real cross validation function that:
 * 
 * export async function validateStrategyModels(
 *   strategy: Strategy,
 *   symbol: string,
 *   k = 5
 * ): Promise<CVMetrics> {
 *   // 1. Extract model configuration from strategy
 *   // 2. Train models on k different time periods  
 *   // 3. Test predictions on out-of-sample data
 *   // 4. Calculate real performance metrics
 *   // 5. Return meaningful validation results
 * }
 */